import { render, staticRenderFns } from "./settingManage.vue?vue&type=template&id=777d9fc8&"
import script from "./settingManage.vue?vue&type=script&lang=js&"
export * from "./settingManage.vue?vue&type=script&lang=js&"
import style0 from "./settingManage.vue?vue&type=style&index=0&id=777d9fc8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports